import React from 'react'
import styled from 'styled-components'
import FontAwesome from 'react-fontawesome'

export const InputText = styled.input`
    text-align: center;
    font-size: 1.4rem;
    border: none;
    border-bottom: 1px solid;
    width: 300px;
    margin: 20px;
    color: #000;
    
    &:focus{
        outline: none;
        border-bottom: 2px solid;
    }
`

export const CountrySelect = styled.div`
    text-align: center;
    font-size: 1.4rem;
    border-bottom: 1px solid;
    position: relative;
    width: 300px;
    margin: 0 auto;
    color: #000;
    height: 40px;
    line-height: 40px;
`

export const CountrySelectIcon = styled(({ isOpened, ...rest }) => <FontAwesome {...rest} />)`
    position: absolute;
    right: 15px;
    
    ${props => (props.isOpened ? `
        top: 15px;
        transform: rotate(180deg);
    ` : `
        top: 3px;
    `)}
`

export const CountrySelectDropDown = styled.div`
    position: absolute;
    top: 40px;
    left: 0;
    background-color: var(--fai-disabled-text-color);
    height: 200px;
    z-index: 100;
    overflow: scroll;
    border: 1px solid #000;
`

export const CountrySelectDropDownItem = styled.div`
    height: 40px;
    line-height: 40px;
    font-size: 1rem;
    border-bottom: 1px solid #fff;
`

export const GardenKnowledgeIconWrapper = styled.div`
    display: inline-block;
    width: 110px;
    height: 100px;
    position: relative;
    text-align: center;
`

export const GardenKnowledgeIcon = styled.img`
    height: 60px;
    width: 60px;
    margin: 0 10px;
`

export const GardenKnowledgeIconDescription = styled.div`
    height: 30px;
    width: 110px;
    text-align: center;
    font-size: 0.9rem;
    position: absolute;
    bottom: 0;
    left: 0;
    color: var(--fai-text-color);
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Pages/Intro.js